import { Link } from "react-router-dom";
import { hotRanking } from "@/mocks/comics";

export default function HotRanking() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <h3
            className="text-xl md:text-2xl font-bold text-foreground-950"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            热门排行
          </h3>
          <span className="flex items-center gap-1 text-xs text-accent-600 bg-accent-100 px-2.5 py-1 rounded-full">
            <i className="ri-fire-line"></i> TOP 10
          </span>
        </div>
        <div className="flex gap-1">
          <button className="px-3 py-1.5 text-xs font-medium rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
            周榜
          </button>
          <button className="px-3 py-1.5 text-xs font-medium rounded-full text-foreground-600 hover:bg-background-100 transition-colors whitespace-nowrap">
            月榜
          </button>
          <button className="px-3 py-1.5 text-xs font-medium rounded-full text-foreground-600 hover:bg-background-100 transition-colors whitespace-nowrap">
            总榜
          </button>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
        {hotRanking.map((comic) => (
          <Link
            key={comic.rank}
            to={`/comic/${comic.slug}`}
            className="group"
          >
            <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3">
              <img
                src={comic.cover}
                alt={comic.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                title={`${comic.title} - 好看的韩国漫画`}
              />
              <div className="absolute top-2 left-2 w-7 h-7 rounded-lg bg-accent-500 flex items-center justify-center">
                <span className="text-xs font-bold text-background-50">{comic.rank}</span>
              </div>
              {comic.rank <= 3 && (
                <div className="absolute top-2 right-2">
                  <i className={`text-lg ${comic.rank === 1 ? "ri-vip-crown-fill text-yellow-400" : comic.rank === 2 ? "ri-medal-fill text-gray-300" : "ri-medal-fill text-amber-600"}`}></i>
                </div>
              )}
            </div>
            <h4 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
              {comic.title}
            </h4>
            <div className="flex items-center gap-2 mt-1">
              <span className="text-xs text-foreground-500">{comic.author}</span>
              <span className="text-xs text-foreground-400">·</span>
              <span className="text-xs text-primary-500">{comic.genre}</span>
            </div>
            <div className="flex items-center gap-2 mt-1">
              <span className="flex items-center gap-0.5 text-xs text-accent-600">
                <i className="ri-star-fill text-[10px]"></i> {comic.rating}
              </span>
              <span className="text-xs text-foreground-400">{comic.views}</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}